if($('.blog-wrapper').length){
    $('.blog-wrapper').append('<div class="text-center"><a href="/nove-z-blogu/" class="btn btn-default">Další články na blogu</a></div>')
}